import React, { useState } from 'react';
import styled from 'styled-components';
import ContactModal from '../shared/ContactModal';

const PartnersMediaSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const partnerTypes = [
    { icon: '🏫', title: 'Schools & Libraries', color: '#3b82f6' },
    { icon: '🏛️', title: 'Museums', color: '#8b5cf6' },
    { icon: '🌱', title: 'Nonprofits', color: '#10b981' },    { icon: '💡', title: 'Forward-Thinking Brands', color: '#f59e0b' }
  ];

  return (
    <Wrapper>
      <ContentContainer>
        <Title>Partners & Media</Title>        <Description>
          We welcome collaborations with schools, libraries, museums, nonprofits, and forward-thinking brands. If you're exploring nature-based learning, youth wellbeing, environmental storytelling and the intersection of AI—and want to help bring <strong>Mission: G.A.I.A.</strong> to life—let's talk.
        </Description>
          <CardGrid>
          {partnerTypes.map((type, index) => (
            <PartnerCard key={index} color={type.color}>
              <IconCircle color={type.color}>
                <Icon>{type.icon}</Icon>
              </IconCircle>
              <CardTitle>{type.title}</CardTitle>
            </PartnerCard>
          ))}
        </CardGrid>        
        <Button onClick={() => setIsModalOpen(true)}>Contact the team</Button>

        <ContactModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)}
          onSubmitSuccess={() => setIsModalOpen(false)}
        />
      </ContentContainer>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100vw;
  background: linear-gradient(120deg, #eaf1fb 0%, #e3eafc 40%, #dbeafe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  padding: 70px 20px;
  // z-index: 9999;

  @media (max-width: 768px) {
    padding: 50px 20px;
  }
  
  @media (max-width: 480px) {
    padding: 40px 15px;
  }
`;

const ContentContainer = styled.div`
  position: relative;
  // z-index: 1;
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h3`
  font-size: 2.8rem;
  font-weight: 800;
  margin: 0 0 25px 0;
  background: linear-gradient(90deg, #1e3a8a 0%, #2563eb 60%, #60a5fa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  text-align: center;

  @media (max-width: 1280px) {
    font-size: 2.5rem;
  }

  @media (max-width: 1024px) {
    font-size: 2.2rem;
  }

  @media (max-width: 768px) {
    font-size: 1.9rem;
    margin-bottom: 20px;
  }

  @media (max-width: 640px) {
    font-size: 1.6rem;
  }

  @media (max-width: 480px) {
    font-size: 1.4rem;
    margin-bottom: 16px;
  }
`;

const Description = styled.p`
  font-size: 1.15rem;
  color: #334155;
  font-weight: 400;
  margin-bottom: 40px;
  line-height: 1.8;
  text-align: center;
  max-width: 900px;
  padding: 0 20px;

  @media (max-width: 1024px) {
    font-size: 1.08rem;
    max-width: 800px;
  }

  @media (max-width: 768px) {
    font-size: 1.02rem;
    margin-bottom: 32px;
    padding: 0 16px;
  }

  @media (max-width: 640px) {
    font-size: 0.98rem;
    line-height: 1.7;
  }

  @media (max-width: 480px) {
    font-size: 0.94rem;
    margin-bottom: 28px;
  }
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 24px;
  width: 100%;
  max-width: 900px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 32px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 16px;
    max-width: 300px;
  }
`;

const PartnerCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.12);
  transition: all 0.3s ease;
  border: 1px solid rgba(30, 64, 175, 0.1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(30, 64, 175, 0.2);
  }

  @media (max-width: 768px) {
    padding: 20px 16px;
    gap: 12px;
  }

  @media (max-width: 480px) {
    padding: 18px 16px;
  }
`;

const IconCircle = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  background: ${props => `${props.color}10`};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${props => `${props.color}30`};

  @media (max-width: 768px) {
    width: 55px;
    height: 55px;
  }

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
  }
`;

const Icon = styled.span`
  font-size: 2rem;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }

  @media (max-width: 480px) {
    font-size: 1.6rem;
  }
`;

const CardTitle = styled.h4`
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e293b;
  text-align: center;
  margin: 0;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    font-size: 0.85rem;
  }
`;

const Button = styled.button`
  background: linear-gradient(90deg, #2563eb 0%, #60a5fa 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 14px 36px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.15);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(90deg, #1e3a8a 0%, #2563eb 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(30, 64, 175, 0.25);
  }

  @media (max-width: 768px) {
    padding: 12px 30px;
    font-size: 0.95rem;
  }

  @media (max-width: 480px) {
    padding: 12px 28px;
    font-size: 0.9rem;
  }
`;

const A = styled.a`
  color: inherit;
  text-decoration: none;
`;

export default PartnersMediaSection;
